/* eslint-disable no-underscore-dangle */
// Seul point d'accès aux globales posées par @vulog-internal/vulog-host-switcher.
import { getSessionStorageItem } from './LocalStorage';

// Évite de télécharger le chunk de la pastille en production.
const PROD_API_PATTERN = /java-(eu|us)|aima-(eu|us)/i;

export const isHostSwitcherMounted = () => Boolean(window.__DEV_HOST_SWITCHER__);

// En dev, le host du switcher remplace le choix de l'ancien sélecteur.
export const getDevHost = () => (isHostSwitcherMounted() ? window.__DEV_HOST__ : getSessionStorageItem('selectedHost'));

export const consumeHostSwitchReturnPath = () =>
    isHostSwitcherMounted() ? window.__DEV_HOST_SWITCHER__.postLoginPath() : null;

export const mountDeployedHostPill = async (host, apiUrl) => {
    if (!apiUrl || PROD_API_PATTERN.test(apiUrl) || isHostSwitcherMounted()) {
        return;
    }
    try {
        const { mountDeployed } = await import('@vulog-internal/vulog-host-switcher/dist/standalone/deployed.js');
        await mountDeployed({ appKey: 'fo', host, apiUrl });
    } catch (error) {
        console.error('Host pill failed to mount', error);
    }
};
